import React from 'react';
import { Button } from 'react-bootstrap';
import { ICON_NEXT_ALT, ICON_PREV_ALT } from '../extras/icons';
//Función principal
const Paginator = props => {
    //Tomo los props
    const {actualPage, totalPages, isFirst, isLast, pageSize, params, loadData} = props;
    //Actualizo la página
    const handlePrev = () => {
        //Actualizo los parámetros
        const newParams = {
            ...params,
            paging: `${actualPage - 1},${pageSize}`,
        }
        //Hago la búsqueda
        loadData(newParams);
    }

    const handleNext = () => {
        //Actualizo los parámetros
        const newParams = {
            ...params,
            paging: `${actualPage + 1},${pageSize}`,
        }
        //Hago la búsqueda
        loadData(newParams);
    }
    //Renderizo
    return (
        <div className="row">
            <div className="col-md-12">
                {
                    !isFirst ? (
                        <Button 
                            className="btn-circle mr-2" 
                            variant="primary" 
                            onClick={handlePrev}>
                            <ICON_PREV_ALT />
                        </Button>
                    ) : null
                }
                <Button variant="primary" disabled={true}>
                    { actualPage + 1 } de { totalPages }
                </Button>
                {
                    !isLast ? (
                        <Button 
                            className="btn-circle ml-2" 
                            variant="outline-primary" 
                            onClick={handleNext}>
                            <ICON_NEXT_ALT />
                        </Button>
                    ) : null
                }
            </div>
        </div>
    );
};

export default Paginator;